import { NextRequest, NextResponse } from 'next/server'
import { ANGEL_COOKIE_DOMAIN, ANONYMOUS_ID_HEADER, SEGMENT_ANONYMOUS_ID_COOKIE } from '@/constants/cookies'
import { AnalyticsEvent } from '@/utils/analytics'
import { isProductionEnvironment } from '@/utils/environment-utils'
import { SegmentNodeTrackParams, track } from '../SegmentNode'
import { cloneNextUrlForPathname } from './MiddlewareNextUrlUtil'
import { NextRedirect } from './types'

export const getCookieDomain = () => (isProductionEnvironment() ? ANGEL_COOKIE_DOMAIN : undefined)

export async function redirectRequest(
  request: NextRequest,
  redirect: NextRedirect,
  trackingEvent: AnalyticsEvent,
  trackingPayload?: SegmentNodeTrackParams,
): Promise<NextResponse> {
  if (trackingPayload) {
    await track(trackingEvent, trackingPayload)
  }

  const isRelativeRedirect = redirect.destination.startsWith('/')
  const url = isRelativeRedirect ? cloneNextUrlForPathname(redirect.destination, request) : redirect.destination
  const status = redirect.permanent ? 308 : 307
  return NextResponse.redirect(url, { status })
}

export const extractAnonymousIdFromNextRequest = (request: NextRequest, onlyCheckCookies: boolean = false) => {
  const anonymousId = request.cookies.get(SEGMENT_ANONYMOUS_ID_COOKIE)?.value

  if (anonymousId) return anonymousId

  if (!onlyCheckCookies) {
    const headerAnonId = request.headers.get(ANONYMOUS_ID_HEADER)
    if (headerAnonId) return headerAnonId
  }

  return null
}
